import React from "react";
import { useWorkspace } from "./workspace/WorkspaceContext";

const cleanSymbol = (symbol = '') =>
  symbol
    .replace(/\s*(LONG|SHORT)$/i, '')
    .replace(/\s*(_UMCBL)$/i, '')
    .trim();

const toTvInterval = (tf) => {
  const n = Number(tf);
  if (!Number.isFinite(n)) return '15';
  if (n === 1440) return 'D';
  if (n === 10080) return 'W';
  return String(n);
};

export default function TradingViewChartIcon({ symbol, timeFrame, exchange, marketType }) {
  const { workspace } = useWorkspace();
  const handleClick = (e) => {
    e.stopPropagation();
    const cleanedSymbol = cleanSymbol(symbol);
    const interval = toTvInterval(timeFrame);
    
    const exchangeFinal = String(exchange || workspace.exchange || '').trim().toUpperCase();
    const marketTypeFinal = String(marketType || workspace.marketType || '').trim().toUpperCase();
    if (!exchangeFinal || !marketTypeFinal) return;
    const suffix = marketTypeFinal === 'PERPS' ? '.P' : '';

    const url =
      `https://www.tradingview.com/chart/?symbol=${exchangeFinal}:${cleanedSymbol}${suffix}&interval=${interval}`;

    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <img
      src="https://www.tradingview.com/favicon.ico"
      alt="TradingView"
      title={`Open in TradingView (${timeFrame}m)`}
      onClick={handleClick}
      style={{
        width: '18px',
        height: '18px',
        cursor: 'pointer'
      }}
    />
  );
}
